document.addEventListener('DOMContentLoaded', () => {
    const disclosureContent = document.querySelector('.js-disclosureContent')
    const filterArchiveButton = document.querySelector('.js-filter-archive')
    const yearsRow = document.querySelectorAll('.disclosureContent__items-year')
    const titleRow = document.querySelectorAll('.js-disclosureContent__title')
    const filesContainer = document.querySelector('.js-disclosureContent__files_container')

    if (disclosureContent && filterArchiveButton) {
        // Check for blocks with data-group="архив"
        const archiveItems = disclosureContent.querySelectorAll('[data-group="архив"]')
        const yearsContainer = disclosureContent.querySelectorAll('.disclosureContent__items-year-container')
        if (archiveItems.length > 0) {
            filterArchiveButton.style.display = 'block'; // Show the button
        } else {
            filterArchiveButton.style.display = 'none'; // Hide the button
        }
        archiveItems.forEach(item => {
            item.style.display = 'none'; // Initially hide archive items
        })
        yearsContainer.forEach(container => {
            const archiveCItems = container.querySelectorAll('[data-group="архив"]')
            const notArchiveCItems = container.querySelectorAll('[data-group=""]')

            if (archiveCItems.length > 0 && notArchiveCItems.length === 0) {
                container.style.display = 'none'; // Hide year if it contains only archive items
            }
        })
        // Add click event listener to the button
        filterArchiveButton.addEventListener('click', () => {
            const allItems = disclosureContent.querySelectorAll('.disclosureContent__item')
            const allPageItems = document.querySelectorAll('.page-item')
            // Remove 'active' class from all page-item elements
            allPageItems.forEach(item => item.classList.remove('active'))
            // Hide all items except those with data-group="архив"

            allItems.forEach(item => {
                if (item.dataset.group === 'архив') {
                    item.style.display = ''; // Show archive items
                } else {
                    item.style.display = 'none'; // Hide non-archive items
                }
            })

            if (filesContainer) {
                const archiveItems = Array.from(allItems).filter(item => item.dataset.group === 'архив')
                // Clear the content of .disclosureContent__files_container
                filesContainer.innerHTML = '';
                // Append all selected archiveItems to .disclosureContent__files_container
                archiveItems.forEach(item => {
                    filesContainer.appendChild(item)
                })
                const items = Array.from(allItems);
                items.sort((a, b) => {
                    const aTime = parseInt(a.getAttribute('data-published_at'), 10) || 0;
                    const bTime = parseInt(b.getAttribute('data-published_at'), 10) || 0;
                    return bTime - aTime; // Сортировка по убыванию
                });

// Добавление года перед первым элементом каждого года
                let lastYear = null;
                items.forEach(item => {
                    const publishedAt = item.getAttribute('data-published_at')
                    const date = new Date(publishedAt * 1000); // Convert to milliseconds
                    const year = date.getFullYear(); // Get the full year

                    if (year && year !== lastYear && item.style.display !== 'none') {
                        const yearLine = createYearLine(year) // Используем функцию createYearLine
                        filesContainer.appendChild(yearLine)
                        lastYear = year
                    }

                    filesContainer.appendChild(item)
                })
            }
            // Add 'active' class to the button
            filterArchiveButton.classList.add('active')
            yearsContainer.forEach(container => {
                    container.style.display = ''
            })
            titleRow.forEach(year => {
                year.style.display = 'none'
            })
            updateVisibility()
        });
    }

    const updateVisibility = () => {
        const itemsContainers = document.querySelectorAll('.disclosureContent__items')
        const filesContainers = document.querySelectorAll('.disclosureContent__files')
        // Step 1: Hide `disclosureContent__items` if all child `disclosureContent__item` blocks are hidden
        itemsContainers.forEach(itemsContainer => {
            const items = itemsContainer.querySelectorAll('.disclosureContent__item')
            const visibleItems = Array.from(items).some(item => item.style.display !== 'none')
            itemsContainer.style.display = visibleItems ? '' : 'none'
        });
        // Step 2: Hide `disclosureContent__files` if all `disclosureContent__items` blocks are hidden
        if (filesContainers) {
            filesContainers.forEach(filesContainer => {
                const items = filesContainer.querySelectorAll('.disclosureContent__items')
                const visibleItems = Array.from(items).some(item => item.style.display !== 'none')
                filesContainer.style.display = visibleItems ? '' : 'none'
            })
        }
    }
    /*Функция создания элемента-ограничителя, который будет подставлен при группировке*/
    const createYearLine = (year) => {
        let element = document.createElement("div")
        let span = document.createElement("span")
        span.innerText = year
        element.classList.add("disclosureContent__items-year")
        element.classList.add("js-year-line")
        element.appendChild(span)

        return element
    }

    updateVisibility()
})
